module.exports = __webpack_public_path__ + "img/cab_1500.eb14d7d2.jpg";